export const DECISION_STATUS_STYLES = {
  ESKALIERT: {
    backgroundColor: 'var(--color-error-surface)',
    color: 'var(--color-error-text)',
  },
  OFFEN: {
    backgroundColor: '#FEF2F2',
    color: 'var(--color-error-text)',
  },
  VORBEREITET: {
    backgroundColor: 'var(--color-warning-surface)',
    color: 'var(--color-warning-text)',
  },
};

export const PORTFOLIO_RISK_STYLES = {
  HOCH: {
    backgroundColor: '#FEF2F2',
    color: 'var(--color-error-text)',
  },
  MITTEL: {
    backgroundColor: 'var(--color-warning-surface)',
    color: 'var(--color-warning-text)',
  },
  NIEDRIG: {
    backgroundColor: 'var(--color-success-surface)',
    color: 'var(--color-success-text)',
  },
};

export function escalationBorderColor(tier) {
  if (tier === 'high') return 'var(--color-error-text)';
  if (tier === 'medium') return 'var(--color-warning-text)';
  return 'var(--color-disabled)';
}

export function isDecisionRelatedCause(label) {
  if (!label) return false;
  const normalized = String(label).toLowerCase();
  return normalized.includes('entscheid') || normalized.includes('decision');
}

export function causeBarColor(label) {
  return isDecisionRelatedCause(label) ? 'var(--color-orange)' : 'var(--color-pink)';
}

export function responsibilityBlockadeColor(count) {
  return count >= 5 ? 'var(--color-error-text)' : 'var(--color-warning-text)';
}

export function openDecisionsColor(count) {
  return count > 0 ? 'var(--color-error-text)' : 'var(--color-success-text)';
}

export function formatPpcTrend(delta) {
  if (delta === null || delta === undefined) return { text: '→ 0%', direction: 'flat' };
  const rounded = Math.round(delta);
  if (rounded > 0) return { text: `+${rounded}%`, direction: 'up' };
  if (rounded < 0) return { text: `${rounded}%`, direction: 'down' };
  return { text: '0%', direction: 'flat' };
}

export const PORTFOLIO_RISK_PAGE_SIZE_DEFAULT = 10;
export const PORTFOLIO_RISK_PAGE_SIZE_MAX = 100;
export const PORTFOLIO_RISK_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export function clampPortfolioRiskPageSize(size) {
  const parsed = Number(size);
  if (!Number.isFinite(parsed)) return PORTFOLIO_RISK_PAGE_SIZE_DEFAULT;
  return Math.max(1, Math.min(PORTFOLIO_RISK_PAGE_SIZE_MAX, Math.round(parsed)));
}

export function normalizePortfolioRiskPaginatorFirst(first, total, pageSize) {
  if (total <= 0) return 0;
  const size = clampPortfolioRiskPageSize(pageSize);
  const remainder = total % size;
  const maxFirst = Math.max(0, total - (remainder || size));
  return Math.min(Math.max(0, first), maxFirst);
}

export function paginateArray(items, first, pageSize) {
  const size = clampPortfolioRiskPageSize(pageSize);
  const start = normalizePortfolioRiskPaginatorFirst(first, items.length, size);
  return items.slice(start, start + size);
}
